import { SubInterestCategory } from '@src/containers/QuizContainer/types';

export const healthcareInterestCategories: SubInterestCategory[] = [
	{
		name: 'Emergency Medical Technician (EMT)',
		description: 'Prepare for a role as an EMT or paramedic.',
		facet: 'Healthcare > Emergency Medical Technician (EMT)',
	},
	{
		name: 'Health Education & Communication ',
		description:
			'Learn how to communicate public health issues and educate communities on healthy habits and environments.',
		facet: 'Healthcare > Health Education & Communication ',
	},
	{
		name: 'Health Information & Technology',
		description:
			'Use technology in the healthcare space to impact patient outcomes through the use of information systems, software, and databases.',
		facet: 'Healthcare > Health Information & Technology',
	},
	{
		name: 'Health Science',
		description: 'Apply scientific knowledge to maintain and improve the health of people.',
		facet: 'Healthcare > Health Science',
	},
	{
		name: 'Healthcare Administration & Management',
		description:
			'Prepare for roles in leadership, management, and administration for healthcare facilities and systems.',
		facet: 'Healthcare > Healthcare Administration & Management',
	},
	{
		name: 'Nursing',
		description: 'Increase your knowledge and skills to prepare for leadership roles in nursing.',
		facet: 'Healthcare > Nursing',
	},
	{
		name: 'Nutrition & Wellness',
		description: 'Study the impact of nutrition and food on people and society.',
		facet: 'Healthcare > Nutrition & Wellness',
	},
	{
		name: 'Optician',
		description: 'Prepare for a role the vision care industry.',
		facet: 'Healthcare > Optician',
	},
	{
		name: 'Pharmacy',
		description: 'Prepare for a role in the pharmaceutical industry.',
		facet: 'Healthcare > Pharmacy',
	},
	{
		name: 'Physiology & Kinesiology',
		description:
			'Advance your knowledge in exercise physiology to become an athletic trainer, physical education teacher, or sports administrator. ',
		facet: 'Healthcare > Physiology & Kinesiology',
	},
	{
		name: 'Psychology & Counseling',
		description:
			'Learn how to best serve people impacted by mental illness, substance abuse, and other health conditions.',
		facet: 'Healthcare > Psychology & Counseling',
	},
	{
		name: 'Public Health',
		description:
			'Prepare for roles in health policy and legislation, learn how to manage health services and facilities, or serve as a consultant on health initiatives.',
		facet: 'Healthcare > Public Health',
	},
	{
		name: 'All healthcare programs',
		description: '',
		facet: 'All healthcare programs',
	},
];
